<template>
  <v-flex xs12 sm6 md3
    :class="paddingClass"
  >
    <v-autocomplete
      v-model.trim="queryTags"
      cache-items
      :loading="isLoading"
      :items="tags"
      item-text="name"
      item-value="id"
      placeholder="Wpisz tag"
      hide-no-data
      multiple
      clearable
      flat
      label="Wybierz tag"
    ></v-autocomplete>
  </v-flex>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'search-by-tag',
  data: () => ({
    selectedTags: [],
    search: null,
    isLoading: false,
    descriptionLimit: 60,
  }),
  computed: {
    ...mapGetters('files', [
      'query',
      'tags',
    ]),
    ...mapGetters('user', [
      'details',
    ]),
    clientId() {
      const { params } = this.$route;
      return params.clientId || this.details.client_id;
    },
    isSearchPage() {
      return this.$route.name === 'searchFiles';
    },
    singleParams() {
      return {
        client_id: this.clientId,
      };
    },
    paddingClass() {
      return this.$vuetify.breakpoint.xs ? 'pr-0' : 'pr-3';
    },
    queryTags: {
      get() {
        let queryParams = this.$route.query.tags_id;
        const tagsType = typeof queryParams;
        if (tagsType === 'string') {
          queryParams = [queryParams];
        }
        return queryParams ? queryParams.map(id => parseInt(id, 0)) : [];
      },
      set(val) {
        this.selectTag(val);
      },
    },
  },
  methods: {
    ...mapActions('files', [
      'setQuery',
      'getTagsList',
    ]),
    async getFilterList() {
      this.isLoading = true;
      try {
        await this.getTagsList();
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    selectTag(tags) {
      if (!this.isSearchPage) {
        this.setQuery(null);
      }
      const newQuery = {
        ...this.query,
        tags_id: tags,
      };
      this.setQuery(newQuery);
      this.$router.push({ path: `/pliki/klient/${this.clientId}/szukaj`, query: newQuery });
    },
  },
  mounted() {
    this.getFilterList();
  },
};
</script>
